import axios from 'axios'

export const TOKEN_KEY = 'standalone.accessToken'

export const api = axios.create({
  baseURL: '/',
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true
})

const bare = axios.create({ baseURL: '/', withCredentials: true })

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem(TOKEN_KEY)
  if (token) cfg.headers.Authorization = `Bearer ${token}`
  return cfg
})

let refreshInFlight = null

export async function refreshAccessToken() {
  if (!refreshInFlight) {
    refreshInFlight = bare
      .post('/api/auth/refresh')
      .then(res => {
        const t = res.data?.token
        if (!t) throw new Error('no token')
        localStorage.setItem(TOKEN_KEY, t)
        window.dispatchEvent(new CustomEvent('standalone:session-refreshed', { detail: res.data }))
        return t
      })
      .finally(() => {
        refreshInFlight = null
      })
  }
  return refreshInFlight
}

const SIGN_IN_PATHS = ['/api/auth/login', '/api/auth/register', '/api/auth/refresh', '/api/auth/logout', '/api/auth/password-reset/']
export function retriesAfterRefresh(url = '') {
  return !SIGN_IN_PATHS.some(p => url.includes(p))
}

api.interceptors.response.use(
  r => r,
  async err => {
    const original = err.config || {}
    const status = err.response?.status
    if (status === 401 && !original._retried && retriesAfterRefresh(original.url)) {
      original._retried = true
      try {
        const token = await refreshAccessToken()
        original.headers = { ...(original.headers || {}), Authorization: `Bearer ${token}` }
        return api(original)
      } catch {
        localStorage.removeItem(TOKEN_KEY)
        if (!location.pathname.startsWith('/login')) location.href = '/login'
      }
    }
    return Promise.reject(err)
  }
)
